import { Box, Flex, FlexProps } from '@chakra-ui/react';
import { ClearButton } from '@morressier/alembic';
import React, { MouseEventHandler, ReactNode } from 'react';
import '../styles.css';

interface ListViewProps {
  children: ReactNode;
}

interface ListViewSubComponentProps extends FlexProps {
  children: ReactNode;
}

const ListView: React.FC<ListViewProps> & {
  Title: React.FC<ListViewSubComponentProps>;
  Body: React.FC<ListViewSubComponentProps>;
  Filters: React.FC<ListViewSubComponentProps>;
  FilterGroup: React.FC<ListViewSubComponentProps>;
  Navigation: React.FC<ListViewSubComponentProps>;
  Tab: React.FC<
    ListViewSubComponentProps & {
      isActive: boolean;
      onClick: MouseEventHandler<HTMLButtonElement>;
    }
  >;
} = ({ children }) => {
  return (
    <Box height="100%" overflow="auto">
      <Box padding={16} minHeight="100%">
        <Flex
          flexDirection="column"
          width="100%"
          alignItems="flex-start"
          gap={4}
        >
          {children}
        </Flex>
      </Box>
    </Box>
  );
};

// Title subcomponent
ListView.Title = ({ children }: ListViewSubComponentProps) => {
  return (
    <Box textStyle="headingTitle" width="100%">
      {children}
    </Box>
  );
};

// Filters subcomponent
ListView.Filters = ({ children }: ListViewSubComponentProps) => {
  return (
    <Flex padding={4} width="100%">
      {children}
    </Flex>
  );
};

ListView.FilterGroup = ({ children, ...props }: ListViewSubComponentProps) => {
  return (
    <Flex gap={2} {...props}>
      {children}
    </Flex>
  );
};

// Body subcomponent
ListView.Body = ({ children }: ListViewSubComponentProps) => {
  return <Box width="100%">{children}</Box>;
};

ListView.Navigation = ({ children }) => {
  return (
    <Flex
      gap={4}
      alignItems="center"
      borderColor="neutralPrimaryBorder"
      borderStyle="solid"
    >
      {children}
    </Flex>
  );
};

ListView.Tab = ({ children, isActive, onClick }) => {
  return (
    <Flex
      paddingX={4}
      paddingY={2}
      borderBottomWidth="2px"
      borderStyle="solid"
      justifyContent="center"
      alignItems="center"
      height="100%"
      _hover={{ bg: 'actionSecondaryFill' }}
      onClick={onClick}
      className={`tab-flex-container ${isActive ? 'is-active' : ''}`}
    >
      <ClearButton
        height="100%"
        ariaLabel={`${children} tab`}
        onClick={onClick}
        textTransform="capitalize"
      >
        {children}
      </ClearButton>
    </Flex>
  );
};

export default ListView;
